import { connect } from 'react-redux'

import TradingPane from '../components/TradingPane'
import { RootState } from '../types'
import {
  openTrade,
  setAmount,
  inputAmount,
  setTakeProfit,
  setStopLoss,
  setTradeType,
  setPrice,
} from '../actions/TradeActions'
import { TradeCommandType } from '@bdswiss/mt4-connector'
import { TradingAction, toggleTradingPane, selectPosition } from '../actions'
import { setChartMode } from '../actions/commonActions'
import { updateFavourites } from '../actions/GraphQLActions'
import { MT4Connector } from '@bdswiss/mt4-connector'
import { Dispatch } from 'redux'

const mt4 = MT4Connector.Instance

export function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  const asset = mt4.assets[state.symbol]
  return {
    accountLoaded: state.accountLoaded,
    assetLoaded: state.assetLoaded,
    account: mt4.account,
    asset: asset,
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
    paneValues: rootState.tradingPane,
    opened: state.tradingPaneOpened,
    chartMode: rootState.appState.chartMode,
    favourites: rootState.favourites,
    userAccount: rootState.userAccount.viewer.accounts.find(acc => Number(acc.login) === mt4.account.login),
  }
}

export function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onSetTradeType: (tradeType: TradeCommandType) => dispatch(setTradeType(tradeType)),
    onSetAmount: (amount: number) => dispatch(setAmount(amount)),
    onInputAmount: (amount: number) => dispatch(inputAmount(amount)),
    onSetTakeProfit: (takeProfit: number) => dispatch(setTakeProfit(takeProfit)),
    onSetStopLoss: (stopLoss: number) => dispatch(setStopLoss(stopLoss)),
    onSetPrice: (price: number) => dispatch(setPrice(price)),
    onTrade: (tradeType: TradeCommandType) => dispatch(openTrade(tradeType)),
    onToggleMenu: () => dispatch(toggleTradingPane()),
    onSetChartMode: () => dispatch(setChartMode('trade')),
    onSelectPosition: (order: number, expanded?: boolean) =>
      dispatch(selectPosition(order, expanded)),
    onToggleFavourite: (favourites: string[]) => dispatch(updateFavourites(favourites)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TradingPane)
